import {Injectable} from "@angular/core";
import {ApiService} from "./api.service";
import {endpoints} from "../../../../environments/endpoints";
import {Observable} from "rxjs";
import {UnityModel} from "../../../models/unity.model";
import {DefaultResponse} from "../../../interfaces/responses";

@Injectable({
    providedIn: "root"
})
export class UnitiesService {
    constructor(private _apiService: ApiService) {
    }

    getUnities(siteId: string): Observable<DefaultResponse<UnityModel[]>> {
        return this._apiService.get(`${endpoints.unities}?siteId=${siteId}`);
    }

    getUnitiesBySites(siteIds: string[]): Observable<DefaultResponse<UnityModel[]>> {
        const siteIdsParams = siteIds.map(id => `siteIds=${id}`).join('&');
        return this._apiService.get(`${endpoints.unities}/by-sites?${siteIdsParams}`);
    }
}
